export function stickySharing() {
    function sticky() {
        let windowWidth = $(window).innerWidth();
        if (windowWidth >= 1200) {
            let content = document.querySelector(".insights-details");
            let stickyBox = document.querySelector(".sharing");
            let stickyBoxInner = stickyBox.querySelector(".inner");
            let stickyBoxHeight = parseInt(getComputedStyle(stickyBoxInner, null).getPropertyValue("height"));
            let wrapPos = content.getBoundingClientRect();
            let indent = windowWidth > 1800 ? 250 : 200;
            if (wrapPos.top <= indent) {
                stickyBox.classList.add("sticky");
            } else {
                stickyBox.classList.remove("sticky");
            }
            if (wrapPos.bottom <= stickyBoxHeight + indent) {
                stickyBox.classList.add("bottom-pos");
            } else {
                stickyBox.classList.remove("bottom-pos");
            }
        }
    }

    window.addEventListener("scroll", () => {
        sticky();
    });

    window.addEventListener("load", () => {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickySharing.js